import { gql as a } from "@apollo/client";
const t = a`
  query GetAdeptusCampaigns($targetTime: Time!) {
    getAdeptusCampaign(input: { targetTime: $targetTime }) {
      adeptusCampaignType
      campaignLink
      campaignID
      metaKey
    }
  }
`;
export {
  t as default
};
//# sourceMappingURL=getAdeptusCampaigns.js.map
